import _sfc_main from "./component-library171.mjs";
import "./component-library172.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.energyDocumentList.length > 1 ? _c(_setup.ListDropdown, { staticClass: "energy-label-datasheet", attrs: { "options": _setup.energyDocumentList, "data-testid": "dropdown", "placeholder": _vm.label }, on: { "input": _setup.openNewTab } }) : _setup.singleItem ? _c("div", { staticClass: "energy-label-datasheet", attrs: { "data-testid": "single" } }, [_c(_setup.LinkButton, { staticClass: "energy-label-datasheet__button", style: `--label-color: ${_vm.labelColor}`, attrs: { "tag": "button", "text": "" }, nativeOn: { "click": function($event) {
    $event.preventDefault();
    return _setup.openNewTab(_setup.singleItem.value);
  } } }, [_vm._v(" " + _vm._s(_vm.label) + " ")])], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8a357a09",
  null,
  null
);
const Datasheet = __component__.exports;
export {
  Datasheet as default
};
